import { Pill as p } from "@flightpath/coreui";
import { PillTypes } from "@flightpath/coreui/dist/ui/Pill";

const Pill = p.Pill;
export { Pill, PillTypes };
